<!--
 * @Descripttion: FORESIGHT SHOP 首页组件 - Blue Business & Feminine Theme
 * @Author: FORESIGHT SHOP
 * @Date: 2026-04-16
-->

<template>
  <div class="home-fofo" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="hero-overlay">
          <div class="hero-badge">New Collection 2026</div>
          <div class="hero-title">Discover Your Perfect Style</div>
          <div class="hero-desc">
            Curated women's fashion that blends elegance with modern sophistication. Explore our exclusive collection of designer pieces.
          </div>
          <router-link class="hero-btn" to="/goods">Explore Collection</router-link>
        </div>
      </div>
    </div>

    <!-- Featured Categories Strip -->
    <div class="featured-strip">
      <div class="featured-strip-inner">
        <div class="featured-item">
          <div class="featured-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"/>
            </svg>
          </div>
          <span>Dresses</span>
        </div>
        <div class="featured-item">
          <div class="featured-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4H6zM3 6h18M16 10a4 4 0 01-8 0"/>
            </svg>
          </div>
          <span>Tops</span>
        </div>
        <div class="featured-item">
          <div class="featured-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span>Bottoms</span>
        </div>
        <div class="featured-item">
          <div class="featured-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
          </div>
          <span>Accessories</span>
        </div>
        <div class="featured-item">
          <div class="featured-icon">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <span>New In</span>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-box">
      <div class="main">
        <!-- Section Header -->
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh styles just for you</p>
        </div>

        <!-- Category Products -->
        <div class="category-products">
          <div class="category-tabs">
            <button
              v-for="cat in homeCategories"
              :key="cat.category_id"
              class="category-tab"
              :class="{ active: activeCategoryId === cat.category_id }"
              @click="selectCategory(cat.category_id)"
            >
              {{ cat.category_name }}
            </button>
          </div>
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Promo Banner Full Width -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time</span>
            <h2>SPRING COLLECTION 2026</h2>
            <p>Up to 50% Off on Designer Dresses & Elegant Sets</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600" alt="Spring Collection" />
          </div>
        </div>

        <!-- Why Shop With Us - Enhanced -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4A6FA5" stroke-width="1.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </div>
            <h3>Free Shipping</h3>
            <p>On orders above $99</p>
          </div>
          <div class="why-item">
            <div class="why-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4A6FA5" stroke-width="1.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <h3>Premium Quality</h3>
            <p>100% authentic products</p>
          </div>
          <div class="why-item">
            <div class="why-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4A6FA5" stroke-width="1.5">
                <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
            </div>
            <h3>Easy Returns</h3>
            <p>30-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4A6FA5" stroke-width="1.5">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                <path d="M1 10h22"/>
              </svg>
            </div>
            <h3>Secure Payment</h3>
            <p>Multiple payment options</p>
          </div>
        </div>

        <!-- Discover Section with Tabs -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Collections</h2>
              <p>Handpicked designs for every occasion</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='DRESSES'}" @click="discoverActive='DRESSES'">Dresses</span>
              <span class="tab-item" :class="{active: discoverActive==='TOPS'}" @click="discoverActive='TOPS'">Tops</span>
              <span class="tab-item" :class="{active: discoverActive==='SETS'}" @click="discoverActive='SETS'">Sets</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">View All</router-link>
        </div>

        <!-- Feature Cards Row -->
        <div class="feature-cards-grid">
          <div class="feature-card">
            <div class="feature-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
            <h3>Exclusive Designs</h3>
            <p>Unique pieces you won't find anywhere else</p>
          </div>
          <div class="feature-card">
            <div class="feature-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5">
                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
              </svg>
            </div>
            <h3>Made with Love</h3>
            <p>Crafted by skilled artisans with care</p>
          </div>
          <div class="feature-card">
            <div class="feature-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              </svg>
            </div>
            <h3>24/7 Support</h3>
            <p>Our team is always here to help</p>
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <span class="new-badge">New Season</span>
              <div class="split-title">Summer Essentials</div>
              <div class="split-desc">
                Light, breathable fabrics perfect for warm days. Stay chic and comfortable.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=600" alt="Summer" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <span class="trending-badge">Trending</span>
              <div class="split-title">Office Elegance</div>
              <div class="split-desc">
                Professional styles that make a statement. Power dressing redefined.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=600" alt="Office" />
            </div>
          </div>
        </div>

        <!-- Inspiration Gallery -->
        <div class="inspiration-section">
          <div class="section-header">
            <h2>Get Inspired</h2>
            <p>Style ideas for every occasion</p>
          </div>
          <div class="inspiration-grid">
            <div class="inspiration-card large">
              <img src="https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=800" alt="Casual Chic" />
              <div class="inspiration-card-content">
                <span class="trending-badge">Casual</span>
                <h3>Weekend Brunch Look</h3>
                <p>Effortless style for your Sunday plans</p>
              </div>
            </div>
            <div class="inspiration-card">
              <img src="https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=600" alt="Evening" />
              <div class="inspiration-card-content">
                <span class="sale-badge">Evening</span>
                <h3>Date Night</h3>
                <p>Romantic outfits for special moments</p>
              </div>
            </div>
            <div class="inspiration-card">
              <img src="https://images.unsplash.com/photo-1509631179647-0177331693ae?w=600" alt="Work" />
              <div class="inspiration-card-content">
                <span class="new-badge">Work</span>
                <h3>Power Meeting</h3>
                <p>Command the room with confidence</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Newsletter Section -->
        <div class="newsletter-section">
          <div class="newsletter-content">
            <h2>Join the FoFo Family</h2>
            <p>Subscribe for exclusive offers, style tips, and early access to new collections.</p>
            <div class="newsletter-form">
              <el-input
                v-model="newsletterEmail"
                placeholder="Enter your email address"
                class="newsletter-input"
              >
                <template slot="append">
                  <el-button class="newsletter-btn">Subscribe</el-button>
                </template>
              </el-input>
            </div>
          </div>
        </div>

        <!-- Additional Banner -->
        <div class="promo-full-banner secondary">
          <div class="promo-image">
            <img src="https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=600" alt="Accessories" />
          </div>
          <div class="promo-content">
            <span class="promo-tag">Just In</span>
            <h2>ACCESSORIES COLLECTION</h2>
            <p>Complete your look with our new jewelry and handbags</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [],
      discoverActive: 'DRESSES',
      dressesList: [],
      topsList: [],
      setsList: [],
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8,
      newsletterEmail: ''
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      return 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1400'
    },
    discoverProducts() {
      if (this.discoverActive === 'DRESSES') return this.dressesList
      if (this.discoverActive === 'TOPS') return this.topsList
      return this.setsList
    }
  },
  activated() {
    this.load()
  },
  methods: {
    load() {
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })

      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)

            const dressesCat = list.find(c => c.category_name.toLowerCase().includes('dress'))
            if (dressesCat) this.getProduct(dressesCat.category_id, 'dressesList')

            const topsCat = list.find(c => c.category_name.toLowerCase().includes('top'))
            if (topsCat) this.getProduct(topsCat.category_id, 'topsList')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })

      rankingAPI
        .listElecRanking()
        .then(res => {
          if (res.status === 200) {
            this.setsList = res.data
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = Array.isArray(res.data.items) ? res.data.items : []
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = res.data.items
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#F8FAFC')
    next()
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#F8FAFC')
    next()
  }
}
</script>

<style scoped>
@import '../assets/css/theme-fofo.css';

/* ============================================
   FOFOSHOP HOME STYLES
   ============================================ */

.hero-banner {
  max-width: 1280px;
  margin: 0 auto;
  height: 520px;
  background-size: cover;
  background-position: center;
  border-radius: 0 0 24px 24px;
  position: relative;
  overflow: hidden;
}

.hero-banner::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(59, 89, 152, 0.92) 0%, rgba(74, 111, 165, 0.85) 50%, rgba(232, 180, 200, 0.5) 100%);
}

.hero-overlay {
  position: relative;
  z-index: 1;
  max-width: 560px;
  padding: 100px 60px;
  color: #ffffff;
}

.hero-badge {
  display: inline-block;
  background: rgba(232, 180, 200, 0.9);
  color: #2D3E50;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.hero-title {
  font-size: 44px;
  line-height: 1.15;
  font-weight: 800;
  margin-bottom: 18px;
  letter-spacing: -0.5px;
}

.hero-desc {
  font-size: 17px;
  line-height: 1.7;
  opacity: 0.95;
  margin-bottom: 32px;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 36px;
  border-radius: 30px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: #ffffff;
  color: #4A6FA5;
  font-weight: 700;
  transition: all 0.25s ease;
}

.hero-btn:hover {
  background: #E8B4C8;
  color: #2D3E50;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

/* Featured Strip */
.featured-strip {
  background: linear-gradient(135deg, #4A6FA5 0%, #3B5998 100%);
  padding: 36px 0;
  margin-bottom: 40px;
}

.featured-strip-inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.featured-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.25s ease;
}

.featured-item:hover {
  transform: translateY(-4px);
}

.featured-icon {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.featured-item span {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Section Header */
.section-header {
  text-align: center;
  margin-bottom: 32px;
}

.section-header h2 {
  font-size: 30px;
  font-weight: 700;
  color: #2D3E50;
  margin-bottom: 8px;
}

.section-header p {
  font-size: 15px;
  color: #4A6FA5;
}

/* Category Products */
.category-products {
  background: #ffffff;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(74, 111, 165, 0.08);
  border: 1px solid rgba(74, 111, 165, 0.08);
  margin-bottom: 40px;
}

.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
}

.category-tab {
  padding: 10px 20px;
  background: transparent;
  border: 1.5px solid rgba(74, 111, 165, 0.15);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  color: #5A6B7D;
  cursor: pointer;
  transition: all 0.2s ease;
}

.category-tab:hover {
  border-color: #4A6FA5;
  color: #4A6FA5;
}

.category-tab.active {
  background: #4A6FA5;
  border-color: #4A6FA5;
  color: #ffffff;
}

/* Promo Full Banner */
.promo-full-banner {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #4A6FA5 0%, #3B5998 60%, #D49FB5 100%);
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 40px;
  min-height: 340px;
  position: relative;
}

.promo-full-banner::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.promo-content {
  flex: 1;
  padding: 48px 56px;
  color: #ffffff;
  position: relative;
  z-index: 1;
}

.promo-tag {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 18px;
}

.promo-content h2 {
  font-size: 38px;
  font-weight: 800;
  margin-bottom: 14px;
}

.promo-content p {
  font-size: 16px;
  opacity: 0.95;
  margin-bottom: 28px;
}

.promo-btn {
  display: inline-flex;
  padding: 14px 28px;
  background: #ffffff;
  color: #4A6FA5;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 25px;
  transition: all 0.25s ease;
}

.promo-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  background: #E8B4C8;
  color: #2D3E50;
}

.promo-image {
  flex: 1;
  height: 340px;
  position: relative;
  z-index: 1;
}

.promo-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Why Section */
.why-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 40px;
  padding: 32px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(74, 111, 165, 0.08);
  border: 1px solid rgba(74, 111, 165, 0.08);
}

.why-item {
  text-align: center;
  padding: 20px;
}

.why-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, rgba(74, 111, 165, 0.1) 0%, rgba(74, 111, 165, 0.05) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.why-item h3 {
  font-size: 16px;
  font-weight: 700;
  color: #2D3E50;
  margin-bottom: 6px;
}

.why-item p {
  font-size: 13px;
  color: #8A9BAD;
}

/* Home Section */
.home-section {
  background: #ffffff;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(74, 111, 165, 0.08);
  border: 1px solid rgba(74, 111, 165, 0.08);
  margin-bottom: 40px;
}

.home-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.section-tabs {
  display: flex;
  gap: 20px;
}

.tab-item {
  font-size: 13px;
  font-weight: 600;
  color: #8A9BAD;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.tab-item.active,
.tab-item:hover {
  color: #4A6FA5;
  border-bottom-color: #4A6FA5;
}

.section-cta {
  display: inline-flex;
  margin-top: 20px;
  padding: 12px 24px;
  border-radius: 20px;
  border: 1.5px solid rgba(74, 111, 165, 0.15);
  font-size: 13px;
  color: #4A6FA5;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.25s ease;
}

.section-cta:hover {
  background: #4A6FA5;
  border-color: #4A6FA5;
  color: #ffffff;
}

/* Feature Cards Grid */
.feature-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.feature-card {
  background: linear-gradient(145deg, #ffffff 0%, #F0EBF7 100%);
  border-radius: 20px;
  padding: 32px;
  text-align: center;
  border: 1px solid rgba(74, 111, 165, 0.08);
  transition: all 0.25s ease;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(74, 111, 165, 0.12);
}

.feature-card-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #4A6FA5 0%, #7B9DCD 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-card h3 {
  font-size: 18px;
  font-weight: 700;
  color: #2D3E50;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 14px;
  color: #7A8BA3;
}

/* Split Banners */
.split-banners-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 40px;
}

.split-banner {
  display: flex;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(74, 111, 165, 0.08);
  border: 1px solid rgba(74, 111, 165, 0.08);
  min-height: 320px;
  transition: all 0.25s ease;
}

.split-banner:hover {
  box-shadow: 0 12px 32px rgba(74, 111, 165, 0.15);
  transform: translateY(-4px);
}

.split-content {
  flex: 1;
  padding: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(135deg, #4A6FA5 0%, #3B5998 100%);
  color: #ffffff;
}

.split-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  margin: 12px 0 14px;
}

.split-desc {
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 24px;
  opacity: 0.95;
}

.new-badge {
  display: inline-block;
  background: #E8B4C8;
  color: #2D3E50;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
}

.trending-badge {
  display: inline-block;
  background: #ffffff;
  color: #4A6FA5;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
}

.split-image {
  flex: 1;
  position: relative;
}

.split-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Inspiration Section */
.inspiration-section {
  margin-bottom: 40px;
}

.inspiration-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 24px;
}

.inspiration-card {
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(74, 111, 165, 0.08);
  transition: all 0.25s ease;
}

.inspiration-card:hover {
  transform: scale(1.02);
  box-shadow: 0 18px 40px rgba(74, 111, 165, 0.12);
}

.inspiration-card.large img {
  height: 380px;
}

.inspiration-card img {
  width: 100%;
  height: 240px;
  object-fit: cover;
}

.inspiration-card-content {
  padding: 20px;
  background: linear-gradient(to bottom, #ffffff, #F0EBF7);
}

.inspiration-card h3 {
  font-size: 16px;
  font-weight: 700;
  color: #2D3E50;
  margin: 8px 0 4px;
}

.inspiration-card p {
  font-size: 13px;
  color: #8A9BAD;
}

.sale-badge {
  display: inline-block;
  background: linear-gradient(135deg, #E8B4C8 0%, #D49FB5 100%);
  color: #2D3E50;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Newsletter Section */
.newsletter-section {
  background: linear-gradient(135deg, #4A6FA5 0%, #3B5998 100%);
  border-radius: 24px;
  padding: 48px;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.newsletter-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.newsletter-content {
  position: relative;
  z-index: 1;
  max-width: 500px;
  margin: 0 auto;
}

.newsletter-content h2 {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
}

.newsletter-content p {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 24px;
}

.newsletter-input {
  border-radius: 25px;
}

.newsletter-input >>> .el-input__inner {
  border-radius: 20px 0 0 20px;
  border: none;
}

.newsletter-input >>> .el-input-group__append {
  border-radius: 0 20px 20px 0;
  background: #E8B4C8;
  border: none;
}

.newsletter-btn {
  background: transparent;
  color: #2D3E50;
  font-weight: 700;
}

/* Secondary Promo Banner */
.promo-full-banner.secondary {
  flex-direction: row-reverse;
}

/* Mobile Responsive */
@media (max-width: 900px) {
  .hero-banner {
    height: 420px;
    border-radius: 0 0 16px 16px;
  }

  .hero-overlay {
    padding: 48px 24px;
    background: rgba(59, 89, 152, 0.9);
  }

  .hero-title {
    font-size: 28px;
  }

  .featured-strip-inner {
    flex-wrap: wrap;
    gap: 20px;
    padding: 0 20px;
  }

  .featured-item {
    flex: 0 0 calc(33.333% - 20px);
  }

  .why-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .feature-cards-grid {
    grid-template-columns: 1fr;
  }

  .split-banners-grid {
    grid-template-columns: 1fr;
  }

  .inspiration-grid {
    grid-template-columns: 1fr;
  }

  .inspiration-card.large img {
    height: 240px;
  }

  .promo-full-banner {
    flex-direction: column;
  }

  .promo-full-banner.secondary {
    flex-direction: column;
  }

  .promo-image {
    width: 100%;
    height: 200px;
  }

  .promo-content {
    padding: 32px 24px;
    text-align: center;
  }

  .promo-content h2 {
    font-size: 28px;
  }

  .newsletter-section {
    padding: 32px 24px;
  }
}
</style>
